import * as actionTypes from "./actionTypes";
import axios from "../../axios-amps";
import { logFirebaseEvent } from "../../shared/utility";
import { serverconfigs } from "../../constants";

export const fetchBalanceBillingHistoryForUserStarted = () => {
  return {
    type: actionTypes.FETCH_BALANCE_BILLING_HISTORY_FOR_USER_STARTED,
  };
};

export const fetchBalanceBillingHistoryForUserSuccess = (
  balanceBillingHistoryForUser
) => {
  return {
    type: actionTypes.FETCH_BALANCE_BILLING_HISTORY_FOR_USER_SUCCESS,
    balanceBillingHistoryForUser: balanceBillingHistoryForUser,
  };
};

export const fetchBalanceBillingHistoryForUserFailed = () => {
  return {
    type: actionTypes.FETCH_BALANCE_BILLING_HISTORY_FOR_USER_FAILED,
  };
};

export const fetchBalanceBillingHistoryForUser = (
  userId: string,
  status: string
) => {
  return (dispatch) => {
    dispatch(fetchBalanceBillingHistoryForUserStarted());
    axios
      .get(serverconfigs.fetchBalanceBillingHistoryForUserUrl+`/${userId}?status=${status}`)
      .then((response) => {
        console.log(response.data);
        dispatch(
          fetchBalanceBillingHistoryForUserSuccess(response.data.result)
        );
      })
      .catch((error) => {
        if (error.statusCode === 400) {
          logFirebaseEvent("Exception400");
        } else if (error.statusCode === 401) {
          logFirebaseEvent("Exception401");
        } else if (error.statusCode === 500) {
          logFirebaseEvent("Exception500");
        }
        dispatch(fetchBalanceBillingHistoryForUserFailed());
      });
  };
};
